export type VpkAnswer = 'yes' | 'no';

export function shouldToggleFortyFiveHours(answer: VpkAnswer, isSelected: boolean): boolean {
    return (answer === 'yes' && !isSelected) || (answer === 'no' && isSelected);
}
